/**
 * Fullwidth Slider
 */

export default function MovileVerticalServiceSlider() {
    const selectors = {
        'slider' : '[data-swiper="mobile-vertical"]',
    };

    let swiper;

    this.init = () => {
        this.slide()
        jQuery(window).on('resize', () => {
            this.slide()
        });
    };

    this.slide = () => {
        if(jQuery(window).width() <= 768){
            this.initSlide();
        }else{
            this.destroySlide();
        }
    }

    this.destroySlide = () => {
        if(swiper){
            swiper.destroy();
            swiper = null;
        }
    }

    this.initSlide = () => {
        if (typeof Swiper == 'function' && !swiper) {
            swiper = new Swiper(selectors.slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                navigation: {
                    nextEl: '.service-button-next',
                    prevEl: '.service-button-prev',
                }
            });
        }
    }
}
